import React, { useState } from 'react';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
import InputComponent from '../../../../components/Input';
import { CATEGORIES, registerInputData } from '../../constants';
import styles from '../../style.module.scss';
import { useForm } from 'react-hook-form';
import { supplierRegister } from '../../registerApi';
import { useConfirmationModal } from '../../../../Redux/context/modalContext';
import { schema } from './schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { isMobile } from '../../../../utils/utils.js';
import {
  moengageTrackEvent,
  APIErrorTrackEvent,
} from '../../../../Analytics/moengageEventFunction';

const EnquiryForm = ({ setActivestep }) => {
  const [loader, setLoader] = useState(false);
  const [selectedCategory, setCategory] = useState(null);
  const { showModal, hideModal } = useConfirmationModal();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ resolver: yupResolver(schema) });
  const handleClick = (cat) => {
    setCategory(cat);
  };

  const onSubmit = async (data) => {
    if (!selectedCategory) {
      alert('Please select atleast one category');
    } else {
      setLoader(true);
      const formdata = {
        ...data,
        category: selectedCategory.value,
      };
      const supplierRegResponse = await supplierRegister(formdata);
      setLoader(false);
      if (supplierRegResponse && supplierRegResponse.data) {
        if (supplierRegResponse.data.status === 'success') {
          showModal({
            message: 'Our Team will reach out to you in next 24 hours',
            handleConfirm: handleConfirm,
          });
          let moePrams = {
            ownerName: data.ownerName,
            mobileNumber: data.mobileNumber,
            category: selectedCategory.value,
            city: data.city,
          };
          moengageTrackEvent('User_Registration_Callback', moePrams);
        } else {
          APIErrorTrackEvent({
            api: supplierRegResponse?.data?.config?.url,
            apiPayLoad: JSON.stringify(formdata),
            errorMsg: supplierRegResponse?.data?.message,
          });
          alert(supplierRegResponse.data.message);
        }
      }
    }
  };

  const handleConfirm = () => hideModal();

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {registerInputData.map((item) => (
          <div key={item.name}>
            {item.type !== 'category' ? (
              <div className="mt-2">
                <InputComponent
                  title={item.title}
                  type={item.type}
                  placeholder={item.placeholder}
                  name={item.name}
                  error={errors[item.name]?.message}
                  {...register(item.name)}
                />
              </div>
            ) : (
              <div className="mt-2">
                <label className="text-muted mt-2">{item.title}</label>

                <DropdownButton
                  id={styles.dropdown_basic_button}
                  variant="secondary"
                  title={selectedCategory ? selectedCategory.label : item.placeholder}
                >
                  {CATEGORIES.map((category, index) => (
                    <Dropdown.Item
                      key={index}
                      eventKey={category.value}
                      onClick={() => handleClick(category)}
                      className={styles.dropdownItemm}
                    >
                      {category.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </div>
            )}
          </div>
        ))}
        <div className={isMobile() ? styles.btn_groupMobile : styles.btn_group}>
          <div className={isMobile() ? 'w-60' : 'w-50 me-5'}>
            <Button
              type="submit"
              className={styles.callback_btn}
              moenagage-id={JSON.stringify({
                eventName: 'User_Self_Register_initiated',
                eventSource: 'User_Self_Register initiated',
              })}
            >
              {!loader ? 'Submit For Callback' : 'Loading...'}
            </Button>
          </div>
          <div className={isMobile() ? 'w-60' : 'w-50'}>
            <Button
              disabled={loader}
              onClick={() => setActivestep('step2')}
              type="button"
              className={styles.register_btn}
            >
              Self Register
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EnquiryForm;
